import React from 'react';
import { CheckSquareIcon } from 'lucide-react';
const sintomas = ['Te levantás cansada aunque hayas dormido bien', 'Tu panza no baja aunque comas poco', 'Sentís retención en la cara, manos y piernas', 'Los antojos de dulce aparecen sin que puedas controlarlos', 'La ropa que antes te quedaba bien ya no cierra igual', 'Tu estado de ánimo cambia sin razón aparente', 'Tenés sensación de pesadez después de comer', 'Sentís que tu metabolismo "está dormido"'];
export function DolorReal() {
  return <section className="bg-esbelta-lavender/40 py-16 md:py-24 px-4" data-id="element-38">
      <div className="max-w-3xl mx-auto" data-id="element-39">
        <h2 className="font-serif text-3xl md:text-5xl font-bold text-gray-900 text-center mb-10 leading-tight" data-id="element-40">
          "Hice todo bien. Y aún así, mi cuerpo no responde."
        </h2>

        <div className="space-y-6 text-lg md:text-xl text-gray-700 leading-relaxed mb-12" data-id="element-41">
          <p data-id="element-42">Si llegaste hasta acá, probablemente ya intentaste de todo.</p>
          <p data-id="element-43">
            Dietas que funcionaron una vez y después dejaron de funcionar.
            Ejercicio que hacés con esfuerzo pero que no mueve la aguja. Mañanas
            que empezás con ganas y terminás sintiéndote igual que siempre:{' '}
            <strong className="text-gray-900" data-id="element-44">
              pesada, hinchada, sin energía.
            </strong>
          </p>
          <p data-id="element-45">Y lo peor no es el espejo.</p>
          <p data-id="element-46">
            Lo peor es esa voz interna que dice:{' '}
            <em className="text-gray-500" data-id="element-47">"quizás esto es lo que me tocó."</em>
          </p>
          <p className="font-bold text-esbelta-violet text-2xl" data-id="element-48">
            No. No es lo que te tocó.
          </p>
          <p data-id="element-49">
            Lo que está pasando es que tu cuerpo después de los 35, 40, 45 años{' '}
            <strong className="text-gray-900" data-id="element-50">
              cambió las reglas del juego.
            </strong>{' '}
            Y nadie te avisó.
          </p>
        </div>

        <div className="bg-white rounded-2xl p-6 md:p-10 shadow-sm border border-gray-100" data-id="element-51">
          <h3 className="flex items-center gap-3 font-bold text-xl md:text-2xl text-gray-900 mb-6" data-id="element-52">
            <span className="flex items-center justify-center w-8 h-8 rounded-full bg-red-100 text-red-500 text-sm" data-id="element-53">
              🔴
            </span>
            ¿Reconocés alguno de estos síntomas?
          </h3>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-8" data-id="element-54">
            {sintomas.map((sintoma, idx) => <div key={idx} className="flex items-start gap-3" data-id="element-55">
                <CheckSquareIcon className="w-5 h-5 text-esbelta-violet flex-shrink-0 mt-0.5" data-id="element-56" />
                <span className="text-gray-700 text-sm md:text-base" data-id="element-57">
                  {sintoma}
                </span>
              </div>)}
          </div>

          <div className="bg-esbelta-lavender/50 rounded-xl p-4 text-center border border-esbelta-violet/20" data-id="element-58">
            <p className="font-bold text-esbelta-violet text-lg" data-id="element-59">
              Si marcaste 3 o más: no es tu voluntad. Es tu equilibrio hormonal.
            </p>
          </div>
        </div>
      </div>
    </section>;
}